import AxiosClient from './api'
import END_POINT from './constants'

export function reset2fa() {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.SETTING_2FA.RESET_2FA}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function verifyCodeReset(code) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.SETTING_2FA.VERIFY_CODE_RESET}/${code}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function verifyCode(code) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.SETTING_2FA.VERIFY_CODE}/${code}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function generateCode() {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.SETTING_2FA.GENERATE}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
